import React from "react";
import { useCustomTranslation } from "../../helpers/translateHelpers";
import Icon from "../icon/Icon";
import { removeDiacritics } from "../../helpers/textHelper";
import { DEBOUNCE_MS } from "../../helpers/debounce";
import { useDebouncedCallback } from "use-debounce";

interface Props {
  onSearch: (phrase: string) => void;
}

const SearchBox: React.FC<Props> = (props): React.ReactElement => {
  const { t } = useCustomTranslation();

  const handleSearch = useDebouncedCallback((value?: string) => {
    props.onSearch(removeDiacritics(value?.toLocaleLowerCase()));
  }, DEBOUNCE_MS);

  return (
    <div className="relative flex items-center">
      <input
        type="text"
        placeholder={t("search_placeholder")}
        className="border-gray-accent text-secondary placeholder-secondary-light hover:border-secondary focus:border-secondary shadow-gray-default block w-full rounded-[10px] border bg-white py-2.5 pr-12 pl-5 text-[14px]/[20px] font-medium autofill:bg-white focus:outline-hidden sm:w-auto"
        onChange={(e) => handleSearch(e.target.value)}
      />
      <Icon name="search" className="absolute right-5" size="small" />
    </div>
  );
};

export default SearchBox;
